import { useQuery, gql } from "@apollo/client";
import { Server } from "../../apollo/types";

interface GetProviderV2RecurringAppointmentsFeatureResult {
  currentProvider?: {
    id: string;
    shouldUseV2RecurringAppointments: boolean;
  };
}

export const GET_PROVIDER_V2_RECURRING_APPOINTMENTS_FEATURE = gql`
  query GetProviderV2RecurringAppointmentsFeature {
    currentProvider {
      id
      shouldUseV2RecurringAppointments
    }
  }
`;

export function useV2RecurringAppointmentsFeature() {
  const { data, loading } =
    useQuery<GetProviderV2RecurringAppointmentsFeatureResult>(
      GET_PROVIDER_V2_RECURRING_APPOINTMENTS_FEATURE,
      {
        context: { server: Server.MONOLITH },
      },
    );

  return {
    loading,
    hasRecurringAppointmentsV2Feature:
      data?.currentProvider?.shouldUseV2RecurringAppointments ?? false,
  };
}
